/**
 * @flow
 * @format
 */

import React from 'react';
import { connect } from 'react-redux';

import _ from 'lodash';
import { Lazy } from 'react-lazy';

import { getFieldValues } from '~/selectors/design';
import { branch } from '~/utils';

// import classes from './LazyImage.scss';
import type { Connector } from 'react-redux';

type OwnPropsType = {
  condition?: { [key: string]: number | string | boolean } | null,
  file: string,
};

type PropsType = {
  shouldRender: boolean,
} & OwnPropsType;

// type StateType = {};

export class LazyImage extends React.PureComponent<PropsType> {
  static defaultProps = {
    condition: {},
  };

  // state: StateType; // eslint-disable-line react/sort-comp
  props: PropsType; // eslint-disable-line react/sort-comp

  /*
  constructor(props: PropsType) {
    super(props);
  }
  */

  render() {
    return branch(
      this.props.shouldRender,
      <Lazy key={this.props.file}>
        <img
          className="img-fluid"
          alt="SubStep"
          src={`${process.env.PUBLIC_URL}/images/${this.props.file}`}
        />
      </Lazy>,
    );
  }
}

function mapStateToProps(
  state: AppStateType,
  ownProps: OwnPropsType,
): PropsType {
  const values = getFieldValues(state);

  // check any field dependancies
  let shouldRender = true;
  const deps = ownProps.condition;
  if (deps) {
    shouldRender = _.every(deps, (value: string | number, key: string) => {
      const fieldValue = _.get(values, [key, 'currentValue']);
      return fieldValue === value;
    });
  }

  return {
    ...ownProps,
    shouldRender,
  };
}

const connector: Connector<OwnPropsType, PropsType> = connect(mapStateToProps);

export default connector(LazyImage);



// WEBPACK FOOTER //
// ./src/components/LazyImage/LazyImage.js